module.exports = __webpack_public_path__ + "img/rank-card-bg.f99f9c57.svg";